import "../styles/index.css";
import "../scss/main.scss";

import "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";
import TabsController from "../controllers/tabs_controller";
import SearchController from "../controllers/search_controller";
import ListGridViewToggleController from "../controllers/list_grid_view_toggle_controller";
import NavigationController from "../controllers/navigation_controller";
import CheckboxController from "../controllers/checkbox_controller"
import RangeController from "../controllers/range_controller"
import YearRangeController from "../controllers/year_range_controller"
import CareerSearchToolController from "../controllers/career_search_tool_controller"
import ScrollTriggerController from '../controllers/scroll_trigger_controller';
import OneItemSwiperController from '../controllers/one_item_swiper_controller';
import TwoItemsSwiperController from '../controllers/two_items_swiper_controller';

import { initFlowbite } from "flowbite";

window.Stimulus = Application.start();

window.Stimulus.register("tabs", TabsController);
window.Stimulus.register("listGridViewToggle", ListGridViewToggleController);
window.Stimulus.register("navigation", NavigationController);
window.Stimulus.register("checkbox", CheckboxController);
window.Stimulus.register("range", RangeController);
window.Stimulus.register("yearRange", YearRangeController);
window.Stimulus.register("careerSearchTool", CareerSearchToolController);
window.Stimulus.register("scrollTrigger", ScrollTriggerController);
window.Stimulus.register("search", SearchController);
window.Stimulus.register("oneItemSwiper", OneItemSwiperController);
window.Stimulus.register("twoItemsSwiper", TwoItemsSwiperController);

document.addEventListener('turbo:load', function () {
  initFlowbite();
});